import { defineMessages } from 'react-intl'

export default defineMessages({
  rejectedMultiple: {
    id: 'component.Commons.Upload.rejectedMultiple',
    defaultMessage: 'You can only send one picture',
  },
  dropRejectedFileType: {
    id: 'component.Commons.Upload.dropRejectedFileType',
    defaultMessage: 'Unable to add this file, please ensure that the format is authorised ({format})',
  },
  dropRejectedFileSize: {
    id: 'component.Commons.Upload.dropRejectedFileSize',
    defaultMessage: 'Unable to add this file, please ensure that the size does not exceed {size}Mb',
  },
  dropRejectedUnknown: {
    id: 'component.Commons.Upload.dropRejectedUnknown',
    defaultMessage: 'Unable to add this file',
  },
  'file-type': {
    id: 'component.MiniApp.FileExchanger.requirements.fileType',
    defaultMessage: 'Format: {value} ',
  },
  'file-size': {
    id: 'component.MiniApp.FileExchanger.requirements.fileSize',
    defaultMessage: 'Weight: {value} ',
  },
  'quantity-of-files': {
    id: 'component.MiniApp.FileExchanger.requirements.quantity',
    defaultMessage: 'Quantity: {value} ',
  },
  'image-height': {
    id: 'component.MiniApp.FileExchanger.requirements.imageHeight',
    defaultMessage: 'Height: {value} ',
  },
  'image-width': {
    id: 'component.MiniApp.FileExchanger.requirements.imageWidth',
    defaultMessage: 'Width: {value} ',
  },
  'image-largestLength': {
    id: 'component.MiniApp.FileExchanger.requirements.imageLargestLength',
    defaultMessage: 'Largest length: {value} ',
  },
  'image-ratio': {
    id: 'component.MiniApp.FileExchanger.requirements.imageRatio',
    defaultMessage: 'Ratio: {value} ',
  },
})
